import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useId, useRef, useState } from "react";
import ErrorTooltip from "../../others/error-tooltip/index.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import * as S from "./styled.js";
export const Checkbox = /*#__PURE__*/ forwardRef(({ label , id =null , value , checked: initialChecked = false , disabled =false , count , className , error , hasError , onChange , onBlur , ...rest }, ref)=>{
    const wrapperRef = useRef(null);
    const uniqueId = useId();
    const [checked, setChecked] = useState(initialChecked);
    useEffect(()=>{
        setChecked(initialChecked);
    }, [
        initialChecked
    ]);
    const handleChange = useCallback((e)=>{
        setChecked(e.target.checked);
        if (onChange) onChange(e.target.checked);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(S.CheckboxWrapper, {
                ref: wrapperRef,
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(S.CheckboxInput, {
                        ref: ref,
                        type: "checkbox",
                        id: id ?? uniqueId,
                        value: value,
                        checked: checked,
                        disabled: disabled,
                        "data-testid": "Checkbox",
                        onChange: handleChange,
                        onBlur: onBlur,
                        ...rest
                    }),
                    /*#__PURE__*/ _jsxs(S.CheckboxLabel, {
                        checked: checked,
                        $hasError: hasError,
                        htmlFor: id ?? uniqueId,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: label
                            }),
                            count && /*#__PURE__*/ _jsx(S.CheckboxLabelCount, {
                                children: count
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ErrorTooltip, {
                referenceElement: wrapperRef.current,
                error: error,
                isVisible: !!hasError
            })
        ]
    });
});
Checkbox.displayName = 'Checkbox';
export const FormCheckbox = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const { field: { value: checked , ...restField } , error , hasError , label  } = useInput({
        type: 'checkbox',
        ...props
    });
    return /*#__PURE__*/ _jsx(Checkbox, {
        ...rest,
        ...restField,
        checked: checked,
        error: error,
        hasError: hasError,
        label: label
    });
};
export default Checkbox;

//# sourceMappingURL=index.js.map